import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

const load = (k, def) => {
  try {
    return JSON.parse(localStorage.getItem(k)) || def;
  } catch {
    return def;
  }
};

export function StoreProvider({ children }) {
  const [cart, setCart] = useState(() => load("ambrai_cart", []));
  const [wishlist, setWishlist] = useState(() => load("ambrai_wishlist", []));

  useEffect(() => {
    localStorage.setItem("ambrai_cart", JSON.stringify(cart));
  }, [cart]);
  useEffect(() => {
    localStorage.setItem("ambrai_wishlist", JSON.stringify(wishlist));
  }, [wishlist]);

  const addToCart = (product, size, quantity = 1, color = "") => {
    setCart((prev) => {
      const key = `${product.slug || product.id}-${size}-${color}`;
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) =>
          i.key === key ? { ...i, quantity: i.quantity + quantity } : i
        );
      }
      return [
        ...prev,
        {
          key,
          product_id: product.id || product.slug,
          slug: product.slug,
          name: product.name,
          price: product.price,
          image: product.primary_image,
          size,
          color,
          quantity,
        },
      ];
    });
    toast.success("Added to your bag", { description: `${product.name} · Size ${size}${color ? ` · ${color}` : ""}` });
  };

  const updateQty = (key, quantity) =>
    setCart((prev) =>
      prev.map((i) => (i.key === key ? { ...i, quantity: Math.max(1, quantity) } : i))
    );

  const removeFromCart = (key) =>
    setCart((prev) => prev.filter((i) => i.key !== key));

  const clearCart = () => setCart([]);

  const toggleWishlist = (product) => {
    setWishlist((prev) => {
      const exists = prev.find((p) => p.slug === product.slug);
      if (exists) {
        toast("Removed from wishlist");
        return prev.filter((p) => p.slug !== product.slug);
      }
      toast.success("Saved to wishlist");
      return [
        ...prev,
        {
          slug: product.slug,
          name: product.name,
          price: product.price,
          primary_image: product.primary_image,
          hover_image: product.hover_image,
          category: product.category,
          sizes: product.sizes,
          id: product.id,
        },
      ];
    });
  };

  const inWishlist = (slug) => wishlist.some((p) => p.slug === slug);

  const cartCount = cart.reduce((a, i) => a + i.quantity, 0);
  const cartTotal = cart.reduce((a, i) => a + i.price * i.quantity, 0);

  return (
    <StoreContext.Provider
      value={{
        cart,
        wishlist,
        addToCart,
        updateQty,
        removeFromCart,
        clearCart,
        toggleWishlist,
        inWishlist,
        cartCount,
        cartTotal,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
}
